import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { BaseList } from '@app/shared/models/list';
import { SMPLog } from '@app/shared/models/log';


@Component({
    selector: 'log-table',
    templateUrl: './log-table.component.html',
    styleUrls: ['./log-table.component.scss']
})
export class LogTableComponent extends BaseComponent
                               implements OnInit {

    @Input()
    public logs: BaseList<SMPLog>;

    constructor() {
        super();
        this._idPrefix = 'log-table.';
    }

    public ngOnInit() {
        super.ngOnInit();

    }

}
